module.exports = __webpack_public_path__ + "img/melissa-sessoes.2d73dfe5.png";